<template>
  <v-content>
    <v-container>
        <v-layout row wrap>
              <v-flex xs12 sm12>
                  <h1 style="font-family: Lato; text-align: center">
                      <span style="color: white"><span class="capitalLetter">R</span>eporting</span>
                  </h1>
                  <hr style="margin-bottom: 30px; margin-left: 10px; margin-right: 10px">
              </v-flex>
              <loading-component v-show="loading"></loading-component>
              <v-flex xs4 sm4>
                <v-hover>
                  <v-card v-show="!loading" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" color="primary">
                    <v-card-title>
                      <download-excel type="button" class="btn btn-default" :data="allEquipmentJsonData" :fields="allEquipmentJsonFields" name="AllEquipmentInWarehousesReport.xls">
                        All Equipment In Warehouses Report
                      </download-excel>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-flex>
              <v-flex xs4 sm4>
                <v-hover>
                  <v-card v-show="!loading" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" color="primary">
                    <v-card-title>
                      <download-excel type="button" class="btn btn-default" :data="workingEquipmentJsonData" :fields="workingEquipmentJsonFields" name="WorkingEquipmentInWarehousesReport.xls">
                        Working Equipment In Warehouses Report
                      </download-excel>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-flex>
              <v-flex xs4 sm4>
                <v-hover>
                  <v-card v-show="!loading" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" color="primary">
                    <v-card-title>
                      <download-excel type="button" class="btn btn-default" :data="faultyEquipmentJsonData" :fields="faultyEquipmentJsonFields" name="FaultyEquipmentInWarehousesReport.xls">
                        Faulty Equipment In Warehouses Report
                      </download-excel>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-flex> 
              <v-flex xs12 sm12 md12 lg12>
                <hr style="margin-bottom: 20px; margin-top: 20px;">
              </v-flex>   
              <v-flex xs4 sm4>
                <v-hover>
                  <v-card v-show="!loading" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" color="primary">
                    <v-card-title>
                      <download-excel type="button" class="btn btn-default" :data="allSerialEquipmentJsonData" :fields="allSerialEquipmentJsonFields" name="AllSerialisedItemsReport.xls">
                        All Equipment In Warehouses Report with Serials
                      </download-excel>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-flex>   
              <v-flex xs4 sm4>
                <v-hover>
                  <v-card v-show="!loading" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" color="primary">
                    <v-card-title>
                      <download-excel type="button" class="btn btn-default" :data="workingSerialEquipmentJsonData" :fields="workingSerialEquipmentJsonFields" name="WorkingSerialisedItemsReport.xls">
                        Working Equipment In Warehouses Report with Serials
                      </download-excel>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-flex>   
              <v-flex xs4 sm4>
                <v-hover>
                  <v-card v-show="!loading" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" color="primary">
                    <v-card-title>
                      <download-excel type="button" class="btn btn-default" :data="faultySerialEquipmentJsonData" :fields="faultySerialEquipmentJsonFields" name="FaultySerialisedItemsReport.xls">
                        Faulty Equipment In Warehouses Report with Serials
                      </download-excel>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-flex>   
              <v-flex xs12 sm12 md12 lg12 xl12 d-flex style="margin:5%">
                <v-select
                  v-model="select"
                  :items='archivedReports.map(object => object.name)'
                  label="Archived Reports"
                ></v-select>
              </v-flex> 
        </v-layout>
        <v-layout justify-space-around>
              <v-flex shrink v-show="reportSelected">
                <v-hover>
                  <v-card v-show="!loading" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" color="primary">
                    <v-card-title>
                      <v-btn color="primary">
                        <a style="color:white" :href='getLinkFromName(select)' class="linkified" target="_blank">Download {{ select }}</a>
                      </v-btn>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-flex>   
        </v-layout>
    </v-container>
  </v-content>
</template>

<script>
const axios = require("axios");
import getSitePass from "../sitepass";
import loadingComponent from '../components/loadingSpinner.vue'

export default {
  name: "Reporting",
  components: {
    loadingComponent,
  },
  data: () => ({
    allEquipmentJsonFields: {},
    allEquipmentJsonData: [], 
    workingEquipmentJsonFields: {},
    workingEquipmentJsonData: [], 
    faultyEquipmentJsonFields: {},
    faultyEquipmentJsonData: [],
    allSerialEquipmentJsonFields: {},
    allSerialEquipmentJsonData: [],
    workingSerialEquipmentJsonFields: {},
    workingSerialEquipmentJsonData: [],
    faultySerialEquipmentJsonFields: {},
    faultySerialEquipmentJsonData: [],
    loadingCount: 0,      
    loading: true,
    archivedReports: [],
    select: '',
    reportSelected: false,
  }),
  watch: {
    loadingCount(newValue, oldValue) {
      if (newValue === 6) {
        this.loading = false
      }
    },
    select(newVal, oldVal) {
      this.reportSelected = true
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getAllEquipmentJSONFieldsAndData() {
      axios
        .get(process.env.VUE_APP_backend_url + "/generateAllEquipmentInWarehouseReport", {
          params: {
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.allEquipmentJsonFields = response.data.jsonFields
          this.allEquipmentJsonData = response.data.jsonData
          this.loadingCount++;
        })
        .catch(function(error) {
          console.log(error);
        })
    },
    getWorkingEquipmentJSONFieldsAndData() {
      axios
        .get(process.env.VUE_APP_backend_url + "/generateWorkingEquipmentInWarehouseReport", {
          params: {
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.workingEquipmentJsonFields = response.data.jsonFields
          this.workingEquipmentJsonData = response.data.jsonData
          this.loadingCount++;
        })
        .catch(function(error) {
          console.log(error);
        })
    },
    getFaultyEquipmentJSONFieldsAndData() {
      axios
        .get(process.env.VUE_APP_backend_url + "/generateFaultyEquipmentInWarehouseReport", {
          params: {
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.faultyEquipmentJsonFields = response.data.jsonFields
          this.faultyEquipmentJsonData = response.data.jsonData
          this.loadingCount++;
        })
        .catch(function(error) {
          console.log(error);
        })
    },    
    getAllSerialEquipmentJSONFieldsAndData() {
      axios
        .get(process.env.VUE_APP_backend_url + "/generateReportWithSerials", {
          params: {
            sitepass: getSitePass(),
            typeOfData: 'all'
          }
        })
        .then(response => {
          this.allSerialEquipmentJsonFields = response.data.jsonFields
          this.allSerialEquipmentJsonData = response.data.jsonData
          this.loadingCount++;
        })
        .catch(function(error) {
          console.log(error);
        })
    },
    getWorkingSerialEquipmentJSONFieldsAndData() {
      axios
        .get(process.env.VUE_APP_backend_url + "/generateReportWithSerials", {
          params: {
            sitepass: getSitePass(),
            typeOfData: 'working'
          }
        })
        .then(response => {
          this.workingSerialEquipmentJsonFields = response.data.jsonFields
          this.workingSerialEquipmentJsonData = response.data.jsonData
          this.loadingCount++;
        })
        .catch(function(error) {
          console.log(error);
        })
    },
    getFaultySerialEquipmentJSONFieldsAndData() {
      axios
        .get(process.env.VUE_APP_backend_url + "/generateReportWithSerials", {
          params: {
            sitepass: getSitePass(),
            typeOfData: 'damaged'
          }
        })
        .then(response => {
          this.faultySerialEquipmentJsonFields = response.data.jsonFields
          this.faultySerialEquipmentJsonData = response.data.jsonData
          this.loadingCount++;
        })
        .catch(function(error) {
          console.log(error);
        })
    },
    getArchivedReports() {
      axios
        .get(process.env.VUE_APP_backend_url + '/getArchivedReports', {
          params: {
            sitepass: getSitePass()
          }
        })
        .then(response => {
          this.archivedReports = response.data
          this.loadingCount++;
        })
    },
    getLinkFromName(name) {
      const index = this.archivedReports.map(object => object.name).indexOf(name)
      if (index < 0) return "" 
      return this.archivedReports[index].exportLink
    },
    initialize() {
      this.getAllEquipmentJSONFieldsAndData();
      this.getWorkingEquipmentJSONFieldsAndData();
      this.getFaultyEquipmentJSONFieldsAndData();
      this.getAllSerialEquipmentJSONFieldsAndData();
      this.getWorkingSerialEquipmentJSONFieldsAndData();
      this.getFaultySerialEquipmentJSONFieldsAndData();
      this.getArchivedReports()
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/reportingView.vue